import dayjs from 'dayjs';

/**
 * 今月の場合trueを返す
 * @param targetDate
 */
export const isThisMonth = (targetDate: Date | string) => {
  return dayjs(new Date()).format(`YYYYMM`) === dayjs(targetDate).format(`YYYYMM`);
};

export default isThisMonth;
